import { Icon } from '@iconify/vue'

export default Icon
